import { Component, Inject, Input } from '@angular/core';
import { AddExperienceComponent } from '../add-experience/add-experience.component';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { GlobalService } from 'src/app/services/global/global.service';
import { PaginationInstance } from 'ngx-pagination';
import { ExperienceDetail } from 'src/app/model/employees';
import { RecruiterService } from 'src/app/services/recruiter/recruiter.service';
import { AppService } from 'src/app/services/app/app.service';
import { CommonService } from 'src/app/services/common/common.service';
import { DeleteItemComponent } from '../../delete-item/delete-item.component';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-experience-detail',
  templateUrl: './experience-detail.component.html',
  styleUrls: ['./experience-detail.component.scss']
})
export class ExperienceDetailComponent {
  public pageSizeOptions = GlobalService.pageSizeOptions;
  public maxPaginationSize = GlobalService.maxPaginationSize
  public config: PaginationInstance = {
    itemsPerPage: this.pageSizeOptions[0],
    currentPage: 0,
  };
  public imageURL: any = GlobalService.imageURL;
  public displayedColumns: string[] = ['experience', 's-date','e-date', 'reference', 'current_employer', 'action'];
  public dataSource = new MatTableDataSource<ExperienceDetail>();
  public count!: any;
  public listArr: ExperienceDetail[] = [
    // {
    //   "id": '',
    //   "e_s": 'IT',
    //   "pos": "Developer",
    //   "st_dt": "2023-05-12",
    //   "ed_dt": "2023-05-12",
    //   "ref": "Vishva",
    //   "n_or": "vishva",
    //   "co_re":"surat",
    //   "c_emp": "yes",
    // }
  ]
  @Input() employeeId!: string | number;
  constructor(
    @Inject(MAT_DIALOG_DATA) public dialogData: any, public dialog: MatDialog, private recruiterService: RecruiterService,
    private appService: AppService, private commonService: CommonService, private spinner: NgxSpinnerService,
  ) { }

  ngOnInit(): void {
    this.dataSource = new MatTableDataSource<ExperienceDetail>(this.listArr);
    this.getList()
  }

  onPageSizeChange(event: Event) {
    const tar = event.target as HTMLInputElement
    this.config.itemsPerPage = Number(tar.value)
    this.config.currentPage = 1
  }
  onPageChange(number: number) {
    this.config.currentPage = number;
  }
  onDeleteItem(itemId: any) {
    const dialogRef = this.dialog.open(DeleteItemComponent, {
      data: {  api_type: 'delete_content',content_type: 'delete_experience', em_i: this.employeeId, id: itemId,  },
      enterAnimationDuration: '300ms', exitAnimationDuration: "300ms"
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.getList()
      }
    });

  }
  onAdd() {
 
    let obj = {
      em_i : this.employeeId, 
    }

    const dialogRef = this.dialog.open(AddExperienceComponent, {
      // width: '95%',
      // height: '95%',
      // maxWidth:'95vw',
      data: obj,
      enterAnimationDuration: '300ms', exitAnimationDuration: "300ms"
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result && result.data_added == true) {
        this.getList()
      }
    });
  }
  onEdit(data) {

    let obj = {
      data: data,
      type: 'edit',
      em_i: this.employeeId,
    }

    const dialogRef = this.dialog.open(AddExperienceComponent, {
      // width: '95%',
      // height: '95%',
      // maxWidth:'95vw',
      data: obj,
      enterAnimationDuration: '300ms', exitAnimationDuration: "300ms"
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result && result.data_added == true) {
        this.getList()
      }
    });
  }

  getList() {
    // this.spinner.show();
    let obj = {
      em_i: this.employeeId,
      start: this.appService.startPageLogic(this.config.currentPage, this.config.itemsPerPage),
      pageSize: this.config.itemsPerPage,
      filter_arr: [],
      search: ""
    }
    this.recruiterService.getExpList(obj).subscribe({
      next: (success: any) => {
        //this.spinner.hide()
        this.dataSource = new MatTableDataSource(success.msg);
        this.count = success.count;
      },
      error: (error: any) => {
        this.commonService.handleError(error);
      },
    });
  }
}
